// src/types/properties/SearchSuggest.ts
var SearchSuggestVerdict = /* @__PURE__ */ ((SearchSuggestVerdict2) => {
  SearchSuggestVerdict2["Destination"] = "destination";
  SearchSuggestVerdict2["Mixed"] = "mixed";
  SearchSuggestVerdict2["Described"] = "described";
  return SearchSuggestVerdict2;
})(SearchSuggestVerdict || {});
var SearchSuggestRail = /* @__PURE__ */ ((SearchSuggestRail2) => {
  SearchSuggestRail2["Places"] = "places";
  SearchSuggestRail2["Destination"] = "destination";
  SearchSuggestRail2["Properties"] = "properties";
  SearchSuggestRail2["AskMaat"] = "ask_maat";
  return SearchSuggestRail2;
})(SearchSuggestRail || {});

export {
  SearchSuggestVerdict,
  SearchSuggestRail
};
